import moment from 'moment';
import initialState from './promoInitialState';
import actions from './promoAction';
import mutations from './promoMutation';

const getters = {
  promoTableData: (state) => {
    const {
      promos,
      activeTab,
    } = state;
    if (activeTab === 'active') {
      return promos.filter((promo) => {
        const notStarted = moment().isBefore(promo.startDate, 'day');
        const hasExpired = moment().isAfter(promo.endDate, 'day');
        return (promo.status === 'Created' || notStarted) && !hasExpired;
      });
    }
    return promos.filter((promo) => {
      const hasExpired = moment().isAfter(promo.endDate, 'day');
      return promo.status !== 'Created' || hasExpired;
    });
  },
  activeCount: (state) => {
    const {
      promos,
    } = state;
    return promos.filter((promo) => {
      const notStarted = moment().isBefore(promo.startDate, 'day');
      const hasExpired = moment().isAfter(promo.endDate, 'day');
      return (promo.status === 'Created' || notStarted) && !hasExpired;
    }).length;
  },
  inactiveCount: (state) => {
    const {
      promos,
    } = state;
    return promos.filter((promo) => {
      const hasExpired = moment().isAfter(promo.endDate, 'day');
      return promo.status !== 'Created' || hasExpired;
    }).length;
  },
};

const promoModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default promoModule;
